import { __assign, __rest } from "tslib";
import React from 'react';
import { transformWireframeProps } from '../../../../../utils/propUtils';
var VeltActivityLogListItemAvatarWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-activity-log-list-item-avatar-wireframe", __assign({}, transformedProps), children));
};
export default VeltActivityLogListItemAvatarWireframe;
